/** Where a cancellation request was made from; the discriminator of the creation body. */
export enum CancellationFlowOrigin {
  /**
   * From an existing policy: the insured, the policy number and the insurer are
   * all read from the policy's insurance flow, so the request names nothing else.
   */
  POLICY = 'POLICY',

  /** From the customer profile, for a policy that doesn't exist on the platform. */
  EXTERNAL = 'EXTERNAL',
}
